import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Half Smoked · Your Cannabis Information Hub</p>
        <h1>Stay Informed on Cannabis Policy and Culture</h1>
        <p className="lede">
          Explore the latest updates on cannabis laws, policies, and cultural insights in your area. 
          Our mission is to provide you with accurate and timely information to navigate the evolving landscape of cannabis.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Explore Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated with the latest changes in cannabis legislation and regulations affecting our community.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear and concise information about the legal status of cannabis in your area, including what is permitted and what is not.
          </p>
        </article>
        <article>
          <h2>Educational Insights</h2>
          <p>
            Access a wealth of resources to educate yourself about cannabis culture, its benefits, and responsible use.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;